import axiosInstance from './axiosInstance';

// Auth API
export const googleLogin = () => {
  window.location.href = `http://bvrithcloud.com/api/auth/google`;
  // window.location.href = `http://localhost:8000/api/auth/google`;
  
};

// Project API
export const getProjects = () => axiosInstance.get('/projects');
export const getMyProjects = () => axiosInstance.get('/projects/my');
export const getProjectById = (id) => axiosInstance.get(`/projects/${id}`);
export const createProject = (data) => axiosInstance.post('/projects', data);
export const updateProject = (id, data) => axiosInstance.put(`/projects/${id}`, data);
export const deleteProject = (id) => axiosInstance.delete(`/projects/${id}`);
export const evaluateProject = (id, data) => axiosInstance.put(`/projects/${id}/evaluate`, data);

// User API
export const getUserProfile = () => axiosInstance.get('/users/me');
export const updateUserProfile = (data) => axiosInstance.put('/users/me', data);
export const getLatestCommit = (projectId) => axiosInstance.get(`/projects/${projectId}/latest-commit`);

export const healthCheck = () => {
    console.log('API Service Placeholder');
};
